<template>
  <div>
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
            variant="white"
            class="btn-icon rounded-circle mr-50 text-primary bg-white"
            size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span>
        Convenio
      </h2>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-2 mb-1">
      <div class="d-flex align-items-center">
        <h3 class="m-0 mr-75">Motivos de ausencia</h3>
        <span v-if="requestTypes.length > 0" class="count-badge">{{ requestTypes.length }} motivos</span>
      </div>
      <b-button
        variant="primary"
        @click="openAddModal"
      >
        Añadir motivo
      </b-button>
    </div>

    <!-- Modal añadir / editar -->
    <b-modal
      v-model="showModal"
      :title="selectedRequestType ? 'Editar motivo de ausencia' : 'Añadir motivo de ausencia'"
      size="md"
      centered
      hide-footer
      @hidden="onModalHidden"
    >
      <add-edit-request-type
        :request-type="selectedRequestType"
        :client-id="currentClient ? currentClient.id : null"
        @success="handleSuccess"
        @cancel="showModal = false"
      />
    </b-modal>

    <!-- Grid de cards -->
    <template v-if="requestTypes.length > 0">
      <div class="request-types-grid">
        <b-card
          v-for="rt in requestTypes"
          :key="rt.id"
          class="rt-card mb-2"
          :class="getBehaviorCardClass(rt.behavior)"
        >
          <div class="d-flex justify-content-between align-items-start">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center mb-1">
                <feather-icon
                  icon="FileTextIcon"
                  size="20"
                  class="mr-75 flex-shrink-0"
                  :class="getBehaviorIconClass(rt.behavior)"
                />
                <h5 class="mb-0 font-weight-bold">
                  {{ rt.name }}
                </h5>
              </div>

              <div class="d-flex align-items-center flex-wrap">
                <span
                  class="custom-badge mr-75 mb-50"
                  :class="getBehaviorBadgeClass(rt.behavior)"
                >
                  <feather-icon
                    icon="TagIcon"
                    size="14"
                    class="mr-25"
                  />
                  {{ behaviorLabel(rt.behavior) }}
                </span>

                <span
                  v-if="rt.requires_approval"
                  class="custom-badge badge-today mb-50 mr-75"
                >
                  <feather-icon
                    icon="CheckCircleIcon"
                    size="14"
                    class="mr-25"
                  />
                  Requiere aprobación
                </span>

                <span
                  v-if="rt.allowed_time && !isVacation(rt)"
                  class="custom-badge badge-holiday mb-50"
                >
                  <feather-icon
                    icon="ClockIcon"
                    size="14"
                    class="mr-25"
                  />
                  {{ rt.allowed_time }}
                </span>
              </div>
            </div>

            <div v-if="!isVacation(rt)" class="d-flex align-items-center ml-1">
              <b-button
                variant="flat-primary"
                size="sm"
                class="btn-icon mr-25"
                @click="openEditModal(rt)"
              >
                <feather-icon
                  icon="Edit2Icon"
                  size="18"
                />
              </b-button>
              <b-button
                variant="flat-danger"
                size="sm"
                class="btn-icon"
                @click="confirmDelete(rt)"
              >
                <feather-icon
                  icon="Trash2Icon"
                  size="18"
                />
              </b-button>
            </div>
          </div>
        </b-card>
      </div>

    </template>

    <template v-else>
      <b-alert
        show
        variant="info"
      >
        <div class="alert-body">
          <feather-icon
            icon="InfoIcon"
            class="mr-50"
          />
          No hay motivos de ausencia configurados. Añade el primero con el botón de arriba.
        </div>
      </b-alert>
    </template>

    <hr class="my-2">

    <!-- Vacaciones -->
    <h3 class="mb-1">Vacaciones</h3>
    <b-card>
      <div class="mb-2">
        <p class="text-muted small">Aquí puedes gestionar los parámetros de vacaciones anuales, acumulables y otras opciones relacionadas con el cliente actual.</p>
      </div>
      <b-row>
        <b-col sm="4">
          <b-form-group label="Días acumulables al acabar el año">
            <b-form-checkbox v-model="accumulable_days" switch :value="1" :unchecked-value="0" />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Días vacaciones anuales">
            <b-form-input v-model="annual_vacation_days" type="number" placeholder="Días vacaciones anuales" />
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group label="Tipo de días de vacaciones">
            <b-form-select v-model="vacation_days_type" :options="vacationDaysTypeOptions" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-right">
          <b-button variant="primary" @click="guardarConfiguracion">Guardar</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BCard,
  BButton,
  BAlert,
  BModal,
  BRow,
  BCol,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BFormSelect,
} from 'bootstrap-vue'
import AddEditRequestType from './AddEditRequestType.vue'

export default {
  components: {
    BCard,
    BButton,
    BAlert,
    BModal,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    AddEditRequestType,
  },
  data() {
    return {
      showModal: false,
      selectedRequestType: null,
      accumulable_days: 0,
      annual_vacation_days: 0,
      vacation_days_type: '',
      vacationDaysTypeOptions: [
        { value: 'laboral', text: 'Días laborables' },
        { value: 'natural', text: 'Días naturales' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      requestTypes: 'requestTypes/getRequestTypes',
      currentClient: 'clients/getCurrentClient',
      calendar: 'calendar/getConfigCalendar',
    }),
  },
  async mounted() {
    await this.listRequestTypes(this.currentClient ? this.currentClient.id : null)
    if (this.currentClient) {
      await this.getCalendar(this.currentClient.id)
      this.setData()
    }
  },
  methods: {
    ...mapActions({
      listRequestTypes: 'requestTypes/list',
      deleteRequestType: 'requestTypes/delete',
      getCalendar: 'calendar/getConfigCalendar',
      editCalendar: 'calendar/edit',
    }),
    setData() {
      this.accumulable_days = this.calendar.accumulable_days || 0
      this.annual_vacation_days = this.calendar.annual_vacation_days || 0
      this.vacation_days_type = this.calendar.vacation_days_type || ''
    },
    async guardarConfiguracion() {
      const data = new FormData()
      data.append('accumulable_days', this.accumulable_days)
      data.append('annual_vacation_days', this.annual_vacation_days)
      data.append('vacation_days_type', this.vacation_days_type)
      data.append('client_id', this.currentClient.id)
      await this.editCalendar({ calendar: data })
    },
    openAddModal() {
      this.selectedRequestType = null
      this.showModal = true
    },
    openEditModal(rt) {
      this.selectedRequestType = rt
      this.showModal = true
    },
    onModalHidden() {
      this.selectedRequestType = null
    },
    handleSuccess() {
      this.showModal = false
    },
    isVacation(rt) {
      return rt.name && rt.name.toLowerCase() === 'vacaciones'
    },
    behaviorLabel(behavior) {
      const labels = {
        justified: 'Justificada',
        unjustified: 'No justificada',
        neutral: 'Neutral',
      }
      return labels[behavior] || behavior
    },
    getBehaviorCardClass(behavior) {
      if (behavior === 'justified') return 'border-left-success'
      if (behavior === 'unjustified') return 'border-left-danger'
      return 'border-left-secondary'
    },
    getBehaviorIconClass(behavior) {
      if (behavior === 'justified') return 'text-success'
      if (behavior === 'unjustified') return 'text-danger'
      return 'text-secondary-dark'
    },
    getBehaviorBadgeClass(behavior) {
      if (behavior === 'justified') return 'badge-approved'
      if (behavior === 'unjustified') return 'badge-pending'
      return 'badge-neutral'
    },
    confirmDelete(rt) {
      this.$bvModal
        .msgBoxConfirm(`¿Estás seguro de eliminar "${rt.name}"?`, {
          bodyClass: 'bodyDelete',
          footerClass: 'footerDelete',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-danger',
          centered: true,
        })
        .then(value => {
          if (value === true) {
            this.deleteRequestType(rt.id)
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.request-types-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
}

.rt-card {
  border-left-width: 4px !important;
  border-left-style: solid !important;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.border-left-success {
    border-left-color: #28c76f !important;
  }

  &.border-left-danger {
    border-left-color: #ea5455 !important;
  }

  &.border-left-secondary {
    border-left-color: #82868b !important;
  }
}

.badge-neutral {
  background-color: rgba(130, 134, 139, 0.12);
  color: #82868b;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.85em;
  display: inline-flex;
  align-items: center;
}

.badge-pending {
  background-color: rgba(234, 84, 85, 0.12);
  color: #ea5455;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.85em;
  display: inline-flex;
  align-items: center;
}

.count-badge {
  background-color: rgba(115, 103, 240, 0.12);
  color: #7367f0;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 0.8rem;
  font-weight: 600;
}
</style>
